import { TActions } from '../../types';
import { EBetPositionStatus, IBetPositionState } from './types';
import {
  LOAD_BET_POSITION_FAIL,
  LOAD_BET_POSITION_START,
  LOAD_BET_POSITION_SUCCESS,
  RESET_BET_POSITION_CACHE,
} from './actions';

export const defaultState: IBetPositionState = {
  status: EBetPositionStatus.initial,
  positionByService: {},
  errorCode: null,
};

export function betPosition(state: IBetPositionState = defaultState, action: TActions): IBetPositionState {
  switch (action.type) {
    case LOAD_BET_POSITION_START: {
      return {
        ...state,
        status: EBetPositionStatus.pending,
        errorCode: null,
      };
    }

    case LOAD_BET_POSITION_SUCCESS: {
      const {
        payload: { serviceId, ...betPosition },
      } = action;

      return {
        ...state,
        status: EBetPositionStatus.success,
        positionByService: {
          ...state.positionByService,
          [serviceId]: betPosition,
        },
      };
    }

    case LOAD_BET_POSITION_FAIL: {
      return {
        ...state,
        status: EBetPositionStatus.fail,
        positionByService: {},
        errorCode: action.payload,
      };
    }

    case RESET_BET_POSITION_CACHE: {
      const { positionByService } = state;
      const serviceId = action.payload;

      return {
        ...state,
        positionByService: {
          [serviceId]: positionByService[serviceId],
        },
      };
    }

    default:
      return state;
  }
}
